import React from 'react';
import PeerAgenciesDashboard from '../components/PeerAgenciesDashboard';

const Main = () => {
  return <PeerAgenciesDashboard />;
};

export default Main;
